// src/App.js

import React, { useEffect } from 'react'
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import PrivateRoute from './routes/PrivateRoute'
import './i18n' 
import { useTranslation } from 'react-i18next'
import Navbar from './components/Navbar'

// Sayfalar
import Profile from './pages/Profile'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'

// Yeni Sayfalar
import ModeratorFormBuilder from './pages/ModeratorFormBuilder'
import UserAnswersPage from './pages/UserAnswersPage'
import DashboardPage from './pages/DashboardPage'
import AdminUsersPage from './pages/AdminUsersPage' // <-- yeni sayfa import'u
import CardReportingPage from './pages/CardReportingPage' 
import CardAnalyticsPage from './pages/CardAnalyticsPage' 
import PlanBillingPage from './pages/PlanBillingPage'
import CustomerAdminPage from './pages/CustomerAdminPage'

function AppContent() {
  const { i18n } = useTranslation()
  const location = useLocation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  const hideNavbar =
    location.pathname.startsWith('/forms/') || location.pathname.startsWith('/user/answers')

  return (
    <AuthProvider>
      {!hideNavbar && <Navbar />}
      <Routes>
        {/* Public routes: kimliklendirme sayfaları */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forms/:shareId" element={<UserAnswersPage isPublic />} />

        {/* Private routes */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        {/* Admin route */}

        {/* Yeni Route'lar */}
        <Route
          path="/moderator/questions"
          element={
            <PrivateRoute >
              <ModeratorFormBuilder />
            </PrivateRoute>
          }
        />
        <Route
          path="/user/answers"
          element={
            <PrivateRoute>
              <UserAnswersPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-answers"
          element={
            <PrivateRoute >
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-answers-card"
          element={
            <PrivateRoute >
              <CardReportingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/CardAnalyticsPage"
          element={
            <PrivateRoute>
              <CardAnalyticsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/customer-admin"
          element={
            <PrivateRoute>
              <CustomerAdminPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/plan-billing"
          element={
            <PrivateRoute>
              <PlanBillingPage />
            </PrivateRoute>
          }
        />


        {/* Yeni: Kullanıcı Yönetimi rotası */}
        <Route
          path="/admin-users"
          element={
            <PrivateRoute adminOnly>
              <AdminUsersPage />
            </PrivateRoute>
          }
        />

        {/* Root: Varsayılan olarak form oluşturucu */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <ModeratorFormBuilder />
            </PrivateRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
